import { render } from "./ModelosCumplimentacionPage.vue?vue&type=template&id=5dbb0423&scoped=true"
import script from "./ModelosCumplimentacionPage.vue?vue&type=script&lang=js"
export * from "./ModelosCumplimentacionPage.vue?vue&type=script&lang=js"

import "./ModelosCumplimentacionPage.vue?vue&type=style&index=0&id=5dbb0423&scoped=true&lang=css"

import exportComponent from "C:\\projects\\Repository\\C318-CAF. Portal de Juntas telematicas\\CAF-Solution\\NetCoreWebApi\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dbb0423"]])

export default __exports__